import React, { PureComponent, Fragment } from 'react'
import { connect } from 'react-redux'

import { localize } from 'helpers/translator'
import FullOverlay from 'views/overlay/full_overlay/FullOverlay'
import Bodymovin from 'components/bodymovin/bodymovin'
import myLibraryActions from 'redux/actions/my_library_actions'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'

import styles from './time_to_climb_overlay.scss'

class TimeToClimbOverlay extends PureComponent {

	createTitle() {
		return (
			<span className={styles.title}>
				{localize('time_to_climb_title_part1_v1')}<br className={styles['line-break']} /> {localize('time_to_climb_title_part2_v1')}
			</span>
		)
	}

	createAsset() {
		return (
			<Fragment>
				<Bodymovin
					path='/assets/media/animations/game.json'
					loop={true}
				>
					<div className={styles.animation}></div>
				</Bodymovin>
				<p className={styles.text}>
					{localize('time_to_climb_text_part1_v1')} <br className={styles['line-break']} />
					{localize('time_to_climb_text_part2_v1')}
				</p>
			</Fragment>
		)
	}

	render() {

		return (
			<FullOverlay
				headerWithBorder={true}
				title={this.createTitle()}
				assetSource={this.createAsset()}
				primaryTextButton={localize('time_to_climb_primaryButton_v1')}
				primaryActionHandler={this.props.actions.explore}
				secondaryTextButton={localize('time_to_climb_secondaryButton')}
				secondaryActionHandler={this.props.actions.cancel}
			/>
		)
	}
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		explore: myLibraryActions.timeToClimbExplore,
		cancel: myLibraryActions.timeToClimbCancelled,
	}, dispatch)
}

export default connect(null, mapDispatchToProps)(TimeToClimbOverlay)
